import { Search } from "lucide-react";

export default function SearchBar({
  value,
  onChange,
}) {
  return (
    <div className="mb-6">

      <div className="relative">

        <Search
          size={20}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
        />

        <input
          type="text"
          placeholder="Rechercher un membre..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="
            w-full
            pl-12
            pr-4
            py-3
            rounded-2xl
            border
            border-gray-300
            bg-white
            shadow-sm
            outline-none
            transition
            focus:border-blue-600
            focus:ring-2
            focus:ring-blue-600
          "
        />

      </div>

    </div>
  );
}